export default __webpack_public_path__ + "static/media/IBM.ddbf0042.png";